// src/lib/subscription.js
import { Auth } from "aws-amplify";

const API_BASE = process.env.REACT_APP_API_BASE;

// Helper to build auth header
async function authHeader() {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return {
    Authorization: `Bearer ${token}`,
  };
}

export async function getSubscriptionStatus() {
  const headers = await authHeader();

  const res = await fetch(`${API_BASE}/subscription/status`, {
    method: "GET",
    headers,
  });

  if (!res.ok) {
    console.error("Status error:", res.status);
    throw new Error(`Status failed: ${res.status}`);
  }

  return res.json(); // { status: "none" | "active" | ... }
}

export async function startCheckout(priceId) {
  const headers = await authHeader();
  const tagId = localStorage.getItem("lpp.tagId") || "UNKNOWN";

  const res = await fetch(`${API_BASE}/billing/checkout`, {
    method: "POST",
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ priceId, tagId }),
  });

  const text = await res.text();

  if (!res.ok) {
    console.error("Checkout error response:", res.status, text);
    throw new Error("Checkout failed: " + res.status);
  }

  let data;
  try {
    data = JSON.parse(text);
  } catch (e) {
    console.error("Checkout returned non-JSON:", text);
    throw e;
  }

  console.log("Stripe checkout url returned:", data?.url);

  if (!data?.url || !String(data.url).startsWith("https://checkout.stripe.com")) {
    throw new Error("Invalid checkout URL returned: " + String(data?.url));
  }

  window.location.href = data.url;
}



// 🧾 Open Stripe Billing Portal (manage / cancel subscription)
export async function openBillingPortal() {
  const headers = await authHeader();

  const res = await fetch(`${API_BASE}/billing/portal`, {
    method: "POST",
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
  });

  if (!res.ok) {
    console.error("Billing portal error:", res.status);
    throw new Error("Billing portal failed: " + res.status);
  }

  const data = await res.json();
  if (!data.url) {
    throw new Error("No portal URL returned");
  }

  window.location.href = data.url;
}
